import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc } from '../../../../../../helpers/custom-prop-types';
const RowActionDefault = (props) => {
    const { onClickOrder, onClickSendOff } = props;
    return (_jsxs("div", Object.assign({ className: 'action_button_box' }, { children: [_jsx("button", Object.assign({ className: 'solution_button primary', onClick: onClickOrder, type: 'button' }, { children: "\u767A\u6CE8" })), _jsx("button", Object.assign({ className: 'solution_button tertiary', onClick: onClickSendOff, type: 'button' }, { children: "\u898B\u9001\u308A" }))] })));
};
RowActionDefault.propTypes = {
    onClickOrder: propFunc().isRequired,
    onClickSendOff: propFunc().isRequired,
};
export default RowActionDefault;
